import router from "@/router";
import om from "../api";
import * as END_POINTS from "../config/constants/end-points";
import * as ACTIONS from "../config/constants/action-types";
import * as MUTATIONS from "../config/constants/mutation-types";

export default {
  /**
   * Action disparada por el router en
   * cada actualización
   * @param {Object} context
   * @param {Object} payload
   */
  [ACTIONS.DO_ROUTE](context, payload) {
    context.commit(MUTATIONS.ON_ROUTE, payload);
    setTimeout(() => {
      // Detener loading al ingresar a ruta nueva
      // Lo hacemos en un timeout = 0 para hacer
      // al final del event loop
      context.commit(MUTATIONS.ON_IS_LOADING, false);
    }, 0);
  },
  /**
   * Mostrar u ocultar el loader
   * @param {Object} context
   * @param {Object} payload
   */
  [ACTIONS.DO_IS_LOADING](context, payload) {
    context.commit(MUTATIONS.ON_IS_LOADING, payload);
  },
  /**
   * App started adobe
   * @param {Object} context
   * @param {Object} payload
   */
  [ACTIONS.DO_ADOBE_APPSTARTED](context, payload) {
    // El evento de click solo debe trackearse con el primer elemento
    // que interactúa
    if (context.state.trackClickElement === null) {
      context.commit("ON_ADOBE_APPSTARTED", payload);
    }
  },
  /**
   * Action genérico para llamadas a la API. Alex
   * Se debe pasar el endpoint, el action a ejecutar en caso
   * de éxito y el action en caso de error
   * @param {Object} context Vue Context
   * @param {endPoint, payload, doSuccess, doError} actionPayload
   */
  [ACTIONS.DO_REQUEST_API](context, { doSuccess, doError, payload }) {
    om.request(payload)
      .then(response => {
        let respuesta = response.data;
        if (respuesta.errorCode === "00") {
          context.dispatch(doSuccess, respuesta);
        } else {
          context.dispatch(doError, respuesta);
        }
      })
      .catch(error => {
        context.dispatch(doError, error);
      });
  },

  /**
   * Actions disparadas por el
   * step navigator para avanzar pasos
   * Cada action guarda el paso
   * actual en el store
   * @param {Object} context
   */
  [ACTIONS.DO_LANDING]: context => {
    let data = context.getters.getConfirmacionData();
    // Indicar cargando
    context.commit(MUTATIONS.ON_IS_LOADING, true);

    // Llamamos al action genérico de request
    // y especificamos el action de éxito y el de error
    // junto con el endpoint + payload
    context.dispatch(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.CONFIRMAR_FORMULARIO,
      doSuccess: ACTIONS.DO_LANDING_SUCCESS,
      doError: ACTIONS.DO_LANDING_ERROR,
      payload: data
    });
  },
  [ACTIONS.DO_LANDING_SUCCESS]: (context, payload) => {
    context.commit(MUTATIONS.ON_GRACIAS, payload);
    router.push("gracias");
  },
  [ACTIONS.DO_LANDING_ERROR]: (context, payload) => {
    // Consulta landing con error
    //Vue.$log.error(payload);
    // Mostrar mensaje de error

    switch (payload.errorCode) {
      case "01":
        context.dispatch(ACTIONS.DO_MENSAJE, 0);
        break;
      case "02":
        context.dispatch(ACTIONS.DO_MENSAJE, 1);
        break;
      case "03":
        context.dispatch(ACTIONS.DO_MENSAJE, 2);
        break;
      default:
        context.dispatch(ACTIONS.DO_MENSAJE, 3);
        break;
    }
  },
  [ACTIONS.DO_PASO1]: (context, payload) => {
    context.commit(MUTATIONS.ON_PASO_1, payload);
  },
  [ACTIONS.DO_GRACIAS]: (context, payload) => {
    context.commit(MUTATIONS.ON_GRACIAS, payload);
  },
  /**
   * Mostrar un mensaje de error
   * @param {Object} context
   * @param {Object} payload Código del mensaje
   */
  [ACTIONS.DO_MENSAJE]: (context, payload) => {
    router.push({
      name: "mensaje",
      params: {
        mje: payload
      }
    });
  }
};
